
import {
    transform,
    isEqual,
    isObject,
} from 'lodash'

export const romanize = (num: number) => {
    if (!+num)
        return ''
    var digits = String(+num).split(''),
        key = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM',
            '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC',
            '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'],
        roman = '',
        i = 3
    while (i--)
        roman = (key[+digits.pop() + (i * 10)] || '') + roman
    return Array(+digits.join('') + 1).join('M') + roman
}

export const getCookie = (c_name) => {
    var c_value = document.cookie,
        c_start = c_value.indexOf(" " + c_name + "=");
    if (c_start == -1) c_start = c_value.indexOf(c_name + "=");
    if (c_start == -1) {
        c_value = null;
    } else {
        c_start = c_value.indexOf("=", c_start) + 1;
        var c_end = c_value.indexOf(";", c_start);
        if (c_end == -1) {
            c_end = c_value.length;
        }
        c_value = unescape(c_value.substring(c_start, c_end));
    }
    return c_value;
}

export const viewport = () => {
    let e = window
    let a = 'inner'
    if (!('innerWidth' in window)) {
        a = 'client'
        // @ts-ignore
        e = document.documentElement || document.body
    }
    // @ts-ignore
    return { width: e[a + 'Width'], height: e[a + 'Height'] }
}


export const diff = (object: any, base: any) => {
    const changes = (object, base) => {
        return transform(object, (result, value, key) => {
            if (!isEqual(value, base[key])) {
                result[key] = (isObject(value) && isObject(base[key])) ? changes(value, base[key]) : value

                if (typeof value === 'function') {
                    delete result[key]
                }
            }
        })
    }

    return changes(object, base)
}

export const holdScrollPosition = (delay: number) => {
    if (typeof window !== undefined) {
        window.holdScrollPosition = true
        setTimeout(() => {
            window.holdScrollPosition = false
        }, delay ? delay : 2000)
    }
}

export interface QueryObj {
    [key: string]: any
}

export const searchToObject = () => {
    const pairs = window.location.search.substring(1).split('&')
    const obj: QueryObj = {}

    for (const i in pairs) {
        if (pairs[i] === '') { continue }

        const pair = pairs[i].split('=')
        obj[decodeURIComponent(pair[0])] = (decodeURIComponent(pair[1]) === 'undefined') ? true : decodeURIComponent(pair[1])
    }

    return obj
}


export const fakeFetch = (url: string, options: any) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            if (Math.random() >= 0.5) {
                resolve()
            } else {
                reject()
            }
        }, 2000)
    })
}

export const fakeAxios = {
    get: fakeFetch,
    post: fakeFetch,
    put: fakeFetch,
    delete: fakeFetch,
}